'use strict';

/*
 created by zhang.yingyu 2019-03-05
 */
angular.module('myShareModule', []).controller('myShareCtrl', [
    '$scope',
    '$q',
    '$window',
    '$state',
    '$modal',
    'modalDialog',
    '$stateParams',
    '$timeout',
    'trsHttpService',
    'initSingleSelecet',
    'storageListenerService',
    'myManuscriptService',
    'trsspliceString',
    'editingCenterService',
    'editNewspaperService',
    'editIsLock',
    function(
        $scope,
        $q,
        $window,
        $state,
        $modal,
        modalDialog,
        $stateParams,
        $timeout,
        trsHttpService,
        initSingleSelecet,
        storageListenerService,
        myManuscriptService,
        trsspliceString,
        editingCenterService,
        editNewspaperService,
        editIsLock
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态函数开始
         * @return {[type]} [description] null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                mediaType: {
                    iwo: '-1',
                    app: '1',
                    web: '2',
                    newspaper: '3',
                },
                copyCurrPage: 1,
                showCopyIndex: -1,
            };
            $scope.manuShareListParams = {
                serviceid: 'mlf_docsharemanage',
                methodname: 'getShareDocs',
                PageSize: $scope.page.PAGESIZE,
                StartPage: $scope.page.CURRPAGE,
                MediaType: $state.params.mediatype,
                SiteId: $state.params.siteid || 0,
            };
            $scope.data = {
                items: [],
                selectedArray: [],
                fusionRouter: {
                    // 融合编辑器路由
                    '1': 'fusionnews',
                    '2': 'fusionatlas',
                    '4': 'fusionlinkdoc',
                    '5': 'fusionactivity',
                    '6': 'fusiontopic',
                    '7': 'fusionvideo',
                    '8': 'fusionlive',
                },
            };
            $scope.status = {
                btnRights: {},
            };
        }

        /**
         * [initData description]初始化数据开始
         * @return {[type]} [description] null
         */
        function initData() {
            getDropDown();
            requestData();
            listenStorage();
        }

        /**
         * [requestData description]获取我的分享列表
         * @return {[type]}            [description]
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.manuShareListParams, 'get').then(function(data) {
                $scope.data.items = data.DATA.content;
                $scope.page.ITEMCOUNT = data.DATA.totalElements;
                $scope.page.PAGECOUNT = data.DATA.totalPages;
                $scope.data.selectedArray = [];
            });
        }

        /**
         * [getShareLinkData description] 获取稿件分享地址
         * @return {[type]}            [description]
         */
        $scope.getShareLinkData = function(url) {
            var params = url.split('?')[1];
            url = window.location.origin + '/manuShareDetail/#/detail?' + params;
            return url;
        };

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenIwo(function() {
                requestData();
                storageListenerService.removeListener('iwo');
            }, $scope);
        }

        /**
         * [showVersionTime description:流程版本时间与操作日志]
         * @param  {[type]} item [description:稿件对象]
         */
        $scope.showVersionTime = function(item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [selectAll description]全选
         * @return {[type]} [description] null
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description]单选
         * @param  {[object]} item [description] 单个对象
         * @return {[type]}      [description] null
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [cancelShareDocUrl description] 取消稿件分享
         */
        $scope.cancelShareDocUrl = function() {
            var params = {
                serviceid: 'mlf_docsharemanage',
            };
            if ($scope.data.selectedArray.length === 1) {
                params.methodname = 'cancelShareDocUrl';
                params.Id = $scope.data.selectedArray[0].id;
            } else {
                params.methodname = 'cancelUrlAll';
                params.Ids = trsspliceString.spliceString($scope.data.selectedArray, 'id', ',');
            }
            modalDialog.confirmModal(
                '删除提示',
                '取消分享后，分享记录将被删除，他人将无法访问此链接。确认取消分享吗？',
                function() {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        if (data.SUCCESS === 'true') {
                            modalDialog.alertType('取消分享成功', '', 'success', false, function() {
                                requestData();
                            });
                        }
                    });
                },
                function() {
                    return;
                }
            );
        };

        /**
         * [copyShareLink description] 分享到剪切板
         */
        $scope.copyShareLink = function(event, url) {
            $scope.status.showSharebg = true;
            event = event || window.event;
            event.stopPropagation();
            var input = document.getElementById('manus_share_cope_link');
            input.value = $scope.getShareLinkData(url);
            input.select();
            document.execCommand('copy');
        };
        document.addEventListener('click', function() {
            $scope.status.showSharebg = false;
        });

        /**
         * [getDropDown description:初始化下拉框]
         */
        function getDropDown() {
            // 初始化选择日期
            $scope.timeTypeJsons = initSingleSelecet.iWoOperTime();
            $scope.timeType = angular.copy($scope.timeTypeJsons[0]);
            // 状态
            $scope.iWoDocStatus = [
                {
                    name: '全部状态',
                    value: '',
                },
                {
                    name: '生效',
                    value: '0',
                },
                {
                    name: '失效',
                    value: '1',
                },
            ];
            $scope.iWoDocStatuSelected = angular.copy($scope.iWoDocStatus[0]);
            // 下拉框单选结束
        }

        /**
         * [searchKeywords description:搜索关键词]
         */
        $scope.searchKeywords = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.manuShareListParams.Title = $scope.keywords;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function(key, value) {
            $scope.manuShareListParams[key] = value;
            $scope.manuShareListParams.StartPage = $scope.status.copyCurrPage = $scope.page.CURRPAGE = '1';
            if (key == 'OperTime') {
                // 我的分享日期特殊处理 --start
                var startDate = $scope.data.fromdate === '' ? '' : $scope.data.fromdate + ' 00:00:00';
                var endDate = $scope.data.untildate === '' ? '' : $scope.data.untildate + ' 23:59:59';
                // 我的分享日期特殊处理 --end
                $scope.manuShareListParams.StartDate = startDate;
                $scope.manuShareListParams.EndDate = endDate;
                $scope.manuShareListParams[key] = null;
            }
            requestData();
        };

        /**
         * [pageChanged description:下一页]
         */
        $scope.pageChanged = function() {
            $scope.manuShareListParams.StartPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description:跳转指定页面]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.manuShareListParams.StartPage = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [selectPageNum description]选择单页显示个数
         * @return {[type]} [description] null
         */
        $scope.selectPageNum = function() {
            $scope.manuShareListParams.PageSize = $scope.page.PAGESIZE;
            $scope.manuShareListParams.StartDate = $scope.page.CURRPAGE;
            $scope.manuShareListParams.StartPage = $scope.status.copyCurrPage = $scope.page.CURRPAGE = '1';
            requestData();
        };
    },
]);
